import { MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";
import PageNotFoundTemplate from "@/design-system/Templates/PageNotFoundTemplate";

const PageNotFound = () => (
    <MainLayout
        header={<Header {...headerConfig} />}
        sidebar={null}
        className=""
        footer={<Footer />}
    >
        <PageNotFoundTemplate />
    </MainLayout>
);

export default PageNotFound;
